<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0" class="pa-2">

      <v-card-title class="text-h5 word-break"><strong>Exceptions</strong></v-card-title>

      <v-card-text class="text-body-1">

        <span class="ml-2 mt-2" v-html="exceptions"></span>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

export default Vue.extend({

  name: 'Exceptions',

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        let exceptions = await axios.get('api/Exception/GetLast10Exceptions');

        this.loading = false;

        this.exceptions = exceptions.data;

      }
      catch
      {
        if (this.$route.path != '/Login') this.$router.push('/Login');
      }

      this.loading = false;

    }, 200)

  },

  data () {

    return {

      loading: false,

      exceptions: ''

    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

th > .v-icon {

  color: white !important;

}

th, td {

  font-size: 18px !important;

}

</style>
